/*eslint-disable */
const $ = window.jQuery = require('jquery');

import countries from '@/services/country.json';
import toast from '@/services/toast';

export default {
  name: 'signup-users-list',
  components: {},
  props: [],
  data () {
    return {
      countryList:[],
      signupedUserApproved:false,
      signupedUserDeclined:false,
      newUserInfoPopup:false,
      signUpedUserResults:[],
      signUpedUserData:null,
    }
  },
  computed: {

  },
  mounted () {
    Object.keys(countries).map((key, index) => {
      this.countryList.push({
        name: countries[key].toLowerCase(),
        value: key.toLowerCase()
      })
    });
    this.countryList.sort((a, b) => (a.name > b.name) ? 1 : -1)
    this.getListOfSignupedUserFunction()
  },
  methods: {
    getListOfSignupedUserFunction(){
      this.$store.dispatch('getListOfSignupedUserFun').then((res) => {
        this.signUpedUserData = res.data 
        this.signUpedUserResults = this.signUpedUserData.data 
      })
    },
    getCountryFlag: function(countryCode, type) {
      if (countryCode == null) {
        countryCode = ''
      }
      let countryName = countryCode.toLowerCase()
      let country = this.countryList.filter(item => (item.value) == (countryName) || (item.name) == (countryName));
      if (country && country.length > 0) {
        country = country[0]
        if (type == 'flag') {
          country = `https://567c9b4f06e54c9c9229fe11191a6432.s3.ca-central-1.amazonaws.com/media/shiny/${country.value}.png`
        } else {
          country = country.name
        }
      } else {
        country = ''
      }
      return country;
    },
    approveUserInfoCheckingFun(data){
      this.newUserInfoPopup = true
      this.newUserInfoData = data
      $("body").addClass("notConnectedUserBody");
    },
    approveUserInfoCheckingCloseFun(){
      this.newUserInfoPopup = false
      this.newUserInfoData = {}
      $("body").removeClass("notConnectedUserBody");
    },
    approvedUserConfirmation(id){
      this.signupedUserApprovedId = id
      this.signupedUserApproved = true
      $("body").addClass("notConnectedUserBody");
    },
    declinedUserConfirmation(id){
      this.signupedUserDeclinedId = id
      this.signupedUserDeclined = true
      $("body").addClass("notConnectedUserBody");
    },
    approvedModalItemConfirmFun(){
      let data = {
        is_active:true,
        accepted:true
      }
      this.$store.dispatch('updateOrgUseDetailsByIdFun', {data: {data: data,id: this.signupedUserApprovedId}})
        .then((res) => {
            toast.success(res.data.msg);
            this.getListOfSignupedUserFunction()
            this.closeApprovedItemModalFun()
        }).catch((err) => {
          toast.error(err.data.data.email);
        })
    },
    closeApprovedItemModalFun(){
      this.signupedUserApproved = false
      $("body").removeClass("notConnectedUserBody");
    },
    declinedModalItemConfirmFun(){
      let data = {
        is_deleted:true
      }
      this.$store.dispatch('updateOrgUseDetailsByIdFun', {data: {data: data, id: this.signupedUserDeclinedId}})
        .then((res) => {
            toast.success(res.data.msg);
            this.getListOfSignupedUserFunction()
            this.closeDeclinedItemModalFun()
        }).catch((err) => {
          toast.error(err.data.data.email);
        })
    },
    closeDeclinedItemModalFun(){
      this.signupedUserDeclined = false
      $("body").removeClass("notConnectedUserBody");
    },
  }
}